<template>
  <div>
    <div slot="header" class="clearfix">
      <span>新手引导预告配置</span>
      <syncVersion :in-method="uploadCdn" :params="params" />
      <!--      <el-button v-permisaction="['config:newUserGuide:uploadCdn']" :loading="loading" size="mini" style="margin-left: 10px" type="primary" @click="uploadCdn()">同步到S3</el-button>-->
    </div>
    <el-table :data="formData" border stripe>
      <el-table-column prop="step" label="关卡等级">
        <template slot-scope="scope">
          <el-input v-model.number="scope.row.level" />
        </template>
      </el-table-column>
      <el-table-column prop="open" label="功能">
        <template slot-scope="scope">
          <el-select v-model="scope.row.open" style="width: 100%" multiple placeholder="请选择">
            <el-option
              v-for="item in openArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="rewards" label="奖励">
        <template slot-scope="scope">
          <Reward :value="scope.row.rewards" />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120px">
        <template slot-scope="scope">
          <el-button v-permisaction="['config:newUserGuide:del']" type="danger" @click="del(scope.$index)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 10px;text-align: center">
      <el-button v-permisaction="['config:newUserGuide:add']" type="primary" @click="add()">+</el-button>
      <el-button v-permisaction="['config:newUserGuide:add']" type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
import Reward from '@/components/Reward/index.vue'
import { getCommonCfg, updateCommonCfg, uploadCdn } from '@/api/config/common-cfg'
import SyncVersion from '@/components/SyncVersion/index.vue'

export default {
  name: 'Teaser',
  components: { SyncVersion, Reward },
  data() {
    return {
      loading: false,
      key: 'NewUserTeaser',
      name: 'NewUserTeaser',
      params: { name: 'NewUserTeaser', type: 'NewUserTeaser' },
      formData: [
        { level: 1, open: [], rewards: [] }
      ],
      openArr: [
        { label: '自动转', value: 1 },
        { label: '野兽', value: 2 },
        { label: '切换bet', value: 3 },
        { label: '卡片收藏', value: 4 },
        { label: '每日任务', value: 5 },
        { label: '锦标赛', value: 6 },
        { label: '4选一活动', value: 7 },
        { label: '公会', value: 8 }
      ]
    }
  },
  created() {
    this.getTables()
  },
  methods: {
    uploadCdn,
    add() {
      this.formData.push({ level: 1, open: [], rewards: [] })
    },
    del(idx) {
      this.formData = this.formData.filter((res, index) => {
        return idx !== index
      })
    },
    getTables() {
      getCommonCfg({ name: this.key }).then(res => {
        this.formData = res.data
      })
    },
    onSubmit() {
      const data = JSON.stringify(this.formData)
      if (data.length < 1) {
        this.msgError('没有需要提交的数据')
      }
      updateCommonCfg({ name: this.key, data: data }).then(res => {
        if (res.code === 200) {
          this.msgSuccess(res.msg)
          this.getTables()
        } else {
          this.msgError(res.msg)
        }
      })
    }
    // uploadCdn() {
    //   this.$confirm('请检查数据是否有误，该操作将同步到S3最新版本?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '再看看',
    //     type: 'warning'
    //   }).then(() => {
    //     uploadCdn({ name: this.name, type: this.key }).then(res => {
    //       if (res.code === 200) {
    //         this.msgSuccess(res.msg)
    //         this.getTables(name)
    //       } else {
    //         this.msgError(res.msg)
    //       }
    //     })
    //   })
    // }
  }
}
</script>

<style scoped>

</style>
